import React, { Component } from "react";
import { connect } from "react-redux";
import { getAnalysisTelemetrySeriesData } from "./selectors/deviceTelemetryChartDataSelector";
import {
  loadDeviceListAnalysisTelemetry,
  resetAnalysisDeviceTelemetryChart,
} from "../deviceTelemetry/actions/deviceTelemetryActions";
import { getSelectedDevice } from "../deviceList/selectors/deviceListSelector";
import { getDates } from "../dataAnalysis/selectors/dataAnalysisSelector";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import DateRange from "../date/DateRange";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { isEmpty } from "../utils/generalUtils";
// import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css";
import { chartColours } from "./chartColours";

class AnalysisDeviceTelemetryChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialLoad: true,
      options: {
        chart: {
          id: "analysisChart",
          height: 750,
          type: "line",
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            autoSelected: "zoom",
          },
        },
        colors: chartColours,
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
          width: [1, 1, 1],
        },
        title: {
          text: "Device Telemetry",
          align: "left",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        yaxis: [
          // NOTE: in order to get the graph yaxis to play nicely, all the series data are named here and individually hidden
          {
            seriesName: "Door - Fridge",
            opposite: true,
            min: 0,
            max: 1,
            tickAmount: 1,
            decicmalsInFloat: 0,
            title: {
              text: "Door / Compressor",
            },
            show: true,
            showAlways: true,
          },
          {
            seriesName: "Temperature - Fridge",
            title: {
              text: "Temperature / Voltage",
            },
            decimalsInFloat: 2,
            show: true,
            showAlways: true,
          },
          {
            opposite: true,
            seriesName: "Door - Fridge",
            decicmalsInFloat: 0,
            title: {
              text: "Compressor",
            },
            show: false,
          },
          {
            seriesName: "Temperature - Fridge", // Note: this is voltage, but uses the series name Temperature - Fridge to ensure they share the same axis
            title: {
              text: "Voltage",
            },
            show: false,
          },
          {
            seriesName: "Temperature - Fridge",
            title: {
              text: "Main Out",
            },
            show: false,
          },
          {
            seriesName: "Temperature - Fridge",
            title: {
              text: "Battery",
            },
            show: false,
          },
          {
            seriesName: "Temperature - Fridge",
            decimalsInFloat: 2,
            title: {
              text: "Product",
            },
            show: false,
          },
          {
            opposite: true,
            seriesName: "Door - Fridge",
            decicmalsInFloat: 0,
            title: {
              text: "Door - Magnet",
            },
            show: false,
          },
        ],
        xaxis: {
          type: "time",
          labels: {
            format: "HH:mm",
          },
          title: {
            text: "Time",
          },
          tickAmount: 10,
        },
      },
    };
  }

  hideSeries() {
    if (this.props.seriesData.length > 0) {
      ApexCharts.exec(
        "analysisChart",
        "toggleSeries",
        "Temperature - Device Chip"
      );
    }
  }

  componentDidUpdate() {
    // todo: causes problems with updates - graph redrawing
    //this.hideSeries();
  }

  loadAnalysisData() {
    this.props.resetAnalysisDeviceTelemetryChart();
    this.props.loadDeviceListAnalysisTelemetry(
      this.props.device.id,
      this.props.selectedDates.startDate,
      this.props.selectedDates.endDate
    );

    this.setState({
      initialLoad: false,
    });
  }

  renderInitialLoad() {
    let initialLoad;

    if (this.state.initialLoad) {
      initialLoad = (
        <div>
          Select a device, data range and press Load Data to view a chart
        </div>
      );
    }

    return initialLoad;
  }

  renderChart() {
    let chart;

    if (!this.state.initialLoad && this.props.seriesData.length > 0) {
      chart = (
        <div id="chartAnalysis">
          <Chart
            options={this.state.options}
            series={this.props.seriesData}
            type="line"
            height={750}
          />
        </div>
      );
    } else {
      chart = <div>No data for selected device</div>;
    }
    return chart;
  }

  render() {
    let device = "No Device Selected";
    if (!isEmpty(this.props.device)) {
      device = this.props.device.name;
    }

    return (
      <div className="content-container">
        <h4>{device} </h4>
        {/* <h2>this.props.seriesData</h2>        
        <div>{JSON.stringify(this.props.seriesData)}</div> */}
        <Row>
          <DateRange></DateRange>
          <Col sm>
            <Button
              variant="primary"
              onClick={this.loadAnalysisData.bind(this)}
            >
              Load Data
            </Button>
          </Col>
        </Row>
        {this.renderInitialLoad()}
        {this.renderChart()}
        {/* <JSONPretty data={this.props.seriesData}></JSONPretty> */}
      </div>
    );
  }
}

AnalysisDeviceTelemetryChart.defaultProps = {
  seriesData: [],
  device: {},
};

function mapStateToProps(state, ownProps) {
  const seriesData = getAnalysisTelemetrySeriesData(state);
  const device = getSelectedDevice(state);
  let selectedDates = {};
  if (!isEmpty(device)) {
    selectedDates = getDates(state);
  }

  return {
    seriesData: seriesData,
    device: device,
    selectedDates: selectedDates,
  };
}

const mapDispatchToProps = {
  loadDeviceListAnalysisTelemetry,
  resetAnalysisDeviceTelemetryChart,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnalysisDeviceTelemetryChart);
